import { type ComponentProps, type ReactNode } from 'react';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface AppTooltipProps extends ComponentProps<typeof Tooltip> {
  title?: string;
  children: ReactNode;
}

export const AppTooltip = ({ title, children, ...props }: AppTooltipProps) => {
  return (
    <Tooltip {...props}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      {title && <TooltipContent>{title}</TooltipContent>}
    </Tooltip>
  );
};
